import { createSelector } from '@reduxjs/toolkit';

import { getPromoInfos } from './getPromoInfos';

export const selectMainPromo = createSelector([getPromoInfos], promos => {
  if (!promos.length) {
    return null;
  }

  return promos[0];
});
